import React, { useState, useEffect } from "react";

export default function CookieConsent() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie_consent");
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookie_consent", "accepted");
    setShowBanner(false);
  };

  return (
    showBanner && (
      <div className="fixed bottom-0 left-0 right-0 bg-gray-900 text-gray-100 border-t border-gray-700 p-4 z-50 shadow-md">
        <div className="max-w-4xl mx-auto flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-sm text-center md:text-left">
            This website uses cookies to enhance your experience and ensure proper functioning.
            By continuing, you agree to our use of cookies.
          </p>
          <button
            onClick={handleAccept}
            className="bg-yellow-500 text-black px-4 py-2 rounded hover:bg-yellow-400 transition"
          >
            Accept
          </button>
        </div>
      </div>
    )
  );
}
